import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * Controls whether [feature] is enabled.
 */
export const FE_SELF_SERVE_BRAND_INSTANT_ANSWERS_241119 = experiment({
  name: "FE_SELF_SERVE_BRAND_INSTANT_ANSWERS_241119",
  identifier: "BrandTokenInSession",
  client: "HELP_CENTER",
  notifyAfter: "2025-02-01",
  defaultValue: false,
  productArea: "HELP_CENTER",
});
